import React from 'react';
import './OrderItem.style.css';
import moment from 'moment';
import { Text } from 'components';
import { stringToMoneyFormat } from 'utils';
import { Button } from 'antd';

const OrderItem = ({ data, onClick, onSubmit, filterKey }) => {
  const {
    order_status,
    menu,
    payment_date,
    coupon_info,
    discount,
    type,
    final_price,
  } = data;
  const statusMapping = {
    READY: 'READY',
    PREPARING: 'PREPARING',
    COMPLETED: 'COMPLETED',
    DELIVERING: 'DELIVERING',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
  };

  const mappedStatus = statusMapping[order_status];

  const menuName =
    menu?.reduce((acc, cur, index) => {
      if (index === 0) acc += `${cur.menu_name} [${cur.num}]개`;
      else acc += ` / ${cur.menu_name} [${cur.num}]개`;
      return acc;
    }, '') ?? '';

  const totalPrice = menu?.reduce((acc, cur) => {
    const optionPrice = cur?.option?.reduce((acc, options) => {
      const menuOptionPrice = options?.option?.reduce((acc, optionDetail) => {
        return (acc += optionDetail.option_price * (optionDetail.count || 1));
      }, 0);
      return (acc += menuOptionPrice);
    }, 0);

    acc += (cur.price + optionPrice) * cur.num;
    return acc;
  }, 0);
  const styles = {
    button: {
      READY: {
        border: '3px solid #0F6CBD',
        color: '#0F6CBD',
      },
      PREPARING: {
        background: '#0F6CBD',
        color: '#FFFFFF',
      },
      COMPLETED: {
        background: 'rgba(15, 108, 189, 0.5)',
        color: '#FFFFFF',
      },
      DELIVERING: {
        background: '#FFA500',
        color: '#FFFFFF',
      },
      DELIVERED: {
        background: '#32CD32',
        color: '#FFFFFF',
      },
      CANCELLED: {
        background: '#FF0000',
        color: '#FFFFFF',
      },
    },
  };

  const getStatusButtonText = (status) => {
    switch (status) {
      case 'READY':
        return '대기중';
      case 'PREPARING':
        return '조리중';
      case 'DELIVERING':
        return '배달중';
      case 'COMPLETED':
      case 'DELIVERED':
        return '완료';
      case 'CANCELLED':
        return '취소됨';
      default:
        return '알 수 없음';
    }
  };

  const getNextStatus = (currentStatus) => {
    if (type === 'ORDER') {
      switch (currentStatus) {
        case 'READY':
          return 'PREPARING';
        case 'PREPARING':
          return 'DELIVERING';
        case 'DELIVERING':
          return 'DELIVERED';
        default:
          return currentStatus;
      }
    } else {
      switch (currentStatus) {
        case 'READY':
          return 'PREPARING';
        case 'PREPARING':
          return 'COMPLETED';
        default:
          return currentStatus;
      }
    }
  };

  return (
    <div
      className="order_item_layout"
      onClick={(e) => {
        e.stopPropagation(); // 모달 열리지 않도록 이벤트 전파 중지
        if (e.target.tagName !== 'BUTTON') {
          onClick && onClick(data);
        }
      }}
    >
      <div>
        <h4>{type}</h4>
        {moment(payment_date).format('YYYY-MM-DD HH시mm분')}
        <p>
          주문시간: <span>{moment(payment_date).format('HH시mm분')}</span>
        </p>
        <p>
          경과시간: <span>{moment(payment_date)?.fromNow()}</span>
        </p>
      </div>

      <div style={{ flex: 1 }}>
        <h4>주문메뉴</h4>
        <Text maxLine={2}>{menuName}</Text>
      </div>

      <div style={{ width: 250 }}>
        <h4>결제금액</h4>
        <p>총 금액: {stringToMoneyFormat(totalPrice, '원')}</p>
        <p>할인/쿠폰: {stringToMoneyFormat(discount, '원')}</p>
        <p>결제금액: {stringToMoneyFormat(final_price, '원')}</p>
        <p>쿠폰 사용: {coupon_info?.length || 0}건</p>
      </div>
      {filterKey === 'REFUNDED' || filterKey === 'ALLORDER' ? (
        <div>
          <Button
            disabled
            style={{
              width: 140,
              height: '100%',
              fontSize: 20,
              ...styles.button[mappedStatus],
            }}
          >
            {getStatusButtonText(mappedStatus)}
          </Button>
        </div>
      ) : (
        <div>
          <Button
            disabled={['COMPLETED', 'DELIVERED', 'CANCELLED'].includes(
              mappedStatus
            )}
            style={{
              width: 140,
              height: '100%',
              fontSize: 20,
              ...styles.button[mappedStatus],
            }}
            onClick={(e) => {
              e.stopPropagation(); // 모달이 열리지 않도록 전파 중지
              const nextStatus = getNextStatus(mappedStatus);
              onSubmit &&
                onSubmit(data?.order_route, data?.order_id, nextStatus);
            }}
          >
            {getStatusButtonText(mappedStatus)}
          </Button>
        </div>
      )}
    </div>
  );
};

export default OrderItem;
